import { Link, useLocation } from 'react-router-dom';
import { useState, useRef } from 'react';

export default function Navigation() {
  const location = useLocation();
  const [showPublications, setShowPublications] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const isPublicationsActive = location.pathname === '/publications' || 
                                location.pathname === '/whitepaper' || 
                                location.pathname === '/state-of-ai-2025' || 
                                location.pathname === '/ai-liability' ||
                                location.pathname === '/constitutional-ai' ||
                                location.pathname === '/cai-engineering-standard' ||
                                location.pathname === '/engineering-trust' ||
                                location.pathname === '/survival-imperative' ||
                                location.pathname === '/infographics' ||
                                location.pathname === '/book-proposal' ||
                                location.pathname === '/playbook-executive-summary' ||
                                location.pathname === '/open-letter-governor-newsom';

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setShowPublications(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setShowPublications(false);
    }, 200);
  };

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'White Papers', path: '/publications' },
    { name: 'Publications', path: '/publications' },
    { name: 'Newsroom', path: '/newsroom' },
    { name: 'Infographics', path: '/infographics' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Analytics', path: '/analytics' },
  ];

  return (
    <nav className="bg-white border-b border-slate-200 sticky top-0 z-50 shadow-sm">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-4 cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/d284d72deac738ef2474c9b45b1f2d97/8d1c59cbea9aa0edafde499b64719af9.png" 
              alt="The Algorithmic Consistency Initiative Logo" 
              className="h-20 w-20 object-contain"
            />
            <h1 className="font-sans text-xl md:text-2xl font-semibold text-slate-900" style={{ fontFamily: "'Inter', sans-serif" }}>
              The Algorithmic Consistency Initiative
            </h1>
          </Link>

          {/* Navigation Links */}
          <div className="hidden lg:flex items-center space-x-8">
            <Link to="/" className="text-slate-700 hover:text-red-800 transition-colors font-medium cursor-pointer">
              Home
            </Link>
            <Link to="/about" className="text-slate-700 hover:text-red-800 transition-colors font-medium cursor-pointer">
              About
            </Link>
            
            {/* Publications Dropdown */}
            <div 
              className="relative"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <button 
                className={`text-slate-700 hover:text-red-800 transition-colors font-medium cursor-pointer flex items-center gap-1 ${isPublicationsActive ? 'text-red-800' : ''}`}
              >
                Publications
                <i className="ri-arrow-down-s-line text-lg"></i>
              </button>
              
              {showPublications && (
                <div className="absolute top-full left-0 mt-2 w-64 bg-white border border-slate-200 shadow-lg rounded-lg py-2 z-50">
                  <Link 
                    to="/publications" 
                    className="block px-4 py-2 text-slate-700 hover:bg-slate-50 hover:text-red-800 transition-colors cursor-pointer"
                  >
                    All Publications
                  </Link>
                  <Link 
                    to="/infographics" 
                    className="block px-4 py-2 text-slate-700 hover:bg-slate-50 hover:text-red-800 transition-colors cursor-pointer"
                  >
                    Infographics
                  </Link>
                  <Link 
                    to="/whitepaper" 
                    className="block px-4 py-2 text-slate-700 hover:bg-slate-50 hover:text-red-800 transition-colors cursor-pointer"
                  >
                    White Papers
                  </Link>
                  <Link 
                    to="/book-proposal" 
                    className="block px-4 py-2 text-slate-700 hover:bg-slate-50 hover:text-red-800 transition-colors cursor-pointer"
                  >
                    Book Proposal
                  </Link>
                  <Link 
                    to="/playbook-executive-summary" 
                    className="block px-4 py-2 text-slate-700 hover:bg-slate-50 hover:text-red-800 transition-colors cursor-pointer"
                  >
                    Playbook Summary
                  </Link>
                  <Link 
                    to="/open-letter-governor-newsom" 
                    className="block px-4 py-2 text-slate-700 hover:bg-slate-50 hover:text-red-800 transition-colors cursor-pointer"
                  >
                    Open Letter
                  </Link>
                </div>
              )}
            </div>

            <Link to="/transcripts" className="text-slate-700 hover:text-red-800 transition-colors font-medium cursor-pointer">
              Transcripts
            </Link>
            <Link to="/newsroom" className="text-slate-700 hover:text-red-800 transition-colors font-medium cursor-pointer">
              Newsroom
            </Link>
            <Link to="/media-kit" className="text-slate-700 hover:text-red-800 transition-colors font-medium cursor-pointer">
              Media Kit
            </Link>
            <Link to="/faq" className="text-slate-700 hover:text-red-800 transition-colors font-medium cursor-pointer">
              FAQ
            </Link>
            <Link
              to="/get-book"
              className="px-6 py-2 bg-red-800 text-white hover:bg-red-900 transition-colors font-medium whitespace-nowrap cursor-pointer rounded-lg"
            >
              Get the Book
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
